// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

export default {
  Alert: {
    close: 'Close'
  },
  Card: {
    select: '選擇',
    titleLinkTooltip: '前往頁面',
    collapseCardTooltip: '摺疊卡片',
    expandCardTooltip: '展開卡片'
  },
  CardList: {
    loadMore: '載入更多',
    notFound: '找不到物件。',
    toolbarSelect: '選擇',
    viewCards: '卡片',
    viewTiles: '方塊',
    viewList: '清單',
    toolbarView: '查看'
  },
  Carousel: {
    nextSlide: 'Next slide',
    previousSlide: 'Previous slide',
    viewSlide: 'View slide %%slideNumber%%'
  },
  ComboBox: {
    close: 'Close',
    open: 'Open'
  },
  ClosingConfirmation: {
    confirm: '離開',
    cancel: '返回',
    content: '確定想要關閉及離開此視窗嗎？將不會儲存任何資料變更。'
  },
  Cuttable: {
    showMore: '顯示更多',
    showLess: '顯示更少'
  },
  Dialog: {
    closeButton: 'Close',
    cancelButton: '取消'
  },
  Drawer: {
    backButton: 'Back',
    closeButton: 'Close',
    hideButton: 'Hide'
  },
  DrawerProgress: {
    cancelButton: '取消'
  },
  Dropdown: {
    close: '關閉'
  },
  Form: {
    submitButton: '儲存',
    applyButton: '套用',
    cancelButton: '取消'
  },
  FormField: {
    clear: '清除',
    remove: '移除',
    addMore: '再新增一個',
    showDescription: 'Show description'
  },
  FormFieldPassword: {
    improvePassword: '若要提升密碼強度：',
    passwordTooShort: '加長密碼。',
    lettersLowerCase: '至少使用一個小寫字母。',
    lettersUpperCase: '至少使用一個大寫字母。',
    numbers1: '至少使用一個數字。',
    numbers3: '至少使用三個數字。',
    specialChar1: '至少使用一個特殊字元（如：!,@,#,$,%,^,&,*,?,_,~）。',
    specialChar2: '至少使用兩個特殊字元（如：!,@,#,$,%,^,&,*,?,_,~）。',
    comboUpperAndLower: '使用大寫和小寫字元。',
    comboLettersAndNumbers: '使用數字與字元。',
    comboLettersNumbersSpecial: '使用數字、字元與特殊字元。',
    yourPasswordIsStrong: '增加長度，使其變得更強。',
    passwordStrength: '密碼強度為%%strength%%。',
    strengthVeryStrong: '非常強',
    strengthStrong: '強',
    strengthVeryWeak: '非常弱',
    strengthWeak: '弱',
    strengthMedium: '中等',
    hidePassword: '隱藏密碼',
    showPassword: '顯示密碼',
    generateButton: '生成',
    copyButtonHint: '複製密碼',
    copySuccessToast: '密碼已複製',
    generateButtonHint: '生成強的密碼'
  },
  InPlaceEdit: {
    cancelButtonHint: '放棄變更',
    editButtonHint: '編輯數值',
    okButtonHint: '儲存變更'
  },
  InputNumber: {
    decrement: 'Decrement',
    increment: 'Increment'
  },
  InputFile: {
    browseButton: '選擇檔案……'
  },
  Layout: {
    openSidebar: 'Expand sidebar',
    closeSidebar: 'Collapse sidebar'
  },
  List: {
    totalRows: '共計 %%totalRows%% 個項目',
    toggleAllRows: 'Toggle all rows',
    toggleRow: 'Toggle row',
    selectedRows: '已選定 %%selectedRows%%（共計： %%totalRows%%）個項目',
    all: '全部',
    allItemsOnPageSelected: '已選擇頁面上所有的項目',
    allItemsSelected: '已選擇所有項目',
    selectAllItems: '選擇所有項目',
    selectAllItemsOnPage: '選擇頁面上所有的項目',
    deselectAll: '取消選擇',
    selectRow: 'Select row',
    selectAllRows: 'Select all rows'
  },
  ListActions: {
    menuButton: 'Open menu'
  },
  ListEmptyView: {
    filteredTitle: '找不到符合篩檢程式的任何項目',
    emptyTitle: '看來這裡什麼都沒有',
    filteredDescription: '最佳化查詢或從篩檢程式中移除一些標準，然後重試。'
  },
  ListOperation: {
    cancelButton: '取消'
  },
  Panel: {
    collapse: 'Collapse',
    expand: 'Expand'
  },
  Pagination: {
    totalShort: '共 %%total%% 項',
    itemsPerPage: '每頁的項目',
    all: '全部',
    total: '第 %%current%% 頁，共 %%total%% 頁'
  },
  Popover: {
    closeButton: 'Close'
  },
  ProgressDialog: {
    closeButton: '關閉',
    cancelButton: '取消'
  },
  Section: {
    collapse: 'Collapse',
    closeButton: 'Close',
    expand: 'Expand'
  },
  Select: {
    clearButton: 'Clear',
    noOptions: '無選項',
    placeholder: '選擇……'
  },
  SearchBar: {
    clearButton: 'Clear',
    searchButton: 'Search',
    collapseSearch: 'Hide search input',
    expandSearch: 'Show search input'
  },
  SpotPopup: {
    total: '%%current%%（共計 %%total%%）'
  },
  SwitchesPanelItem: {
    showDescription: 'Show description'
  },
  Tabs: {
    closeButton: 'Close tab'
  },
  Toaster: {
    closeGroup: '關閉群組'
  },
  Toast: {
    closeButton: 'Close'
  }
};